import {Converter, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalPage} from "./PortalPage";
import {PortalConverterHeaderFooter} from "./PortalConverterHeaderFooter";
import {PortalConverterHtml} from "./PortalConverterHtml";

export const TransformationSystemLanguage = "system"

export enum XmlMode {
	TEXT = "text",
	XRECHNUNG = "xrechnung",
	TRANSFORM = "transform"
}

export enum ConverterType {
	OUTSIDEIN = "default",
	OFFICE_BRIDGE = "officeBridge",
	SHAREPOINT = "sharepoint",
	SHAREPOINT_ONLINE = "sharepointOnline"
}

export class PortalConverter extends Converter implements Parameter {
	public archive?: boolean;
	public conversionAsHTML?: boolean;
	public xRechnung?: boolean;
	public xRechnungOverwrite?: boolean;
	public xslTransformation?: boolean;
	public xmlMode?: XmlMode;
	public header?: PortalConverterHeaderFooter;
	public footer?: PortalConverterHeaderFooter;
	public converterType?: ConverterType;

	constructor(data: any) {
		super(data);

		this.archive = FunctionHelper.exists(data?.archive) ? data.archive : false;
		this.conversionAsHTML = FunctionHelper.exists(data?.conversionAsHTML) ? data.conversionAsHTML : true;
		this.xRechnung = FunctionHelper.exists(data?.xRechnung) ? data.xRechnung : false;
		this.xRechnungOverwrite = FunctionHelper.exists(data?.xRechnungOverwrite) ? data.xRechnungOverwrite : false;
		this.xslTransformation = FunctionHelper.exists(data?.xslTransformation) ? data.xslTransformation : false;
		this.xmlMode = FunctionHelper.exists(data?.xmlMode) ? data.xmlMode : XmlMode.TEXT;
		this.page = PortalPage.fromJson(data?.page);
		this.header = PortalConverterHeaderFooter.fromJson(data?.header);
		this.footer = PortalConverterHeaderFooter.fromJson(data?.footer);
		this.html = PortalConverterHtml.fromJson(data?.html);
		this.converterType = FunctionHelper.exists(data?.converterType) ? data.converterType : ConverterType.OUTSIDEIN;
	}

	public static getArchiveDefault(): boolean {
		return false;
	}

	public static getConversionAsHTMLDefault(): boolean {
		return true;
	}

	public static getXRechnungDefault(): boolean {
		return false;
	}

	public static getXRechnungOverwriteDefault(): boolean {
		return false;
	}

	public static getXslTransformationDefault(): boolean {
		return false;
	}

	public static getConverterTypeDefault(): ConverterType {
		return ConverterType.OUTSIDEIN;
	}

	public static getXmlModeDefault(): XmlMode {
		return XmlMode.TEXT;
	}

	public static fromJson(data: any): PortalConverter {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalConverter(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'archive': this.archive,
			'conversionAsHTML': this.conversionAsHTML,
			'xRechnung': this.xRechnung,
			'xRechnungOverwrite': this.xRechnungOverwrite,
			'xslTransformation': this.xslTransformation,
			'xmlMode': this.xmlMode,
			'header': this.header?.toJson(),
			'footer': this.footer?.toJson(),
			'converterType': this.converterType
		};
	}

	public clone(): PortalConverter {
		return PortalConverter.fromJson(this.toJson());
	}
}